<template>
  <section></section>
</template>
<script>
import { mapGetters } from 'vuex'
import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr'
import globals from '@/plugins/globals'
const signalrUrl = window.config ? window.config.signalrUrl : ''
export default {
  name: 'service-hub',
  data() {
    return {
      connection: null,
      signalRstatus: '',
      signalRerror: '',
      connectedInterval: 0
    }
  },
  mounted() {
    this.initSignalR()
  },
  computed: {
    ...mapGetters('auth', ['token', 'profile'])
  },
  methods: {
    initSignalR() {
      try {
        // Initialize SignalR
        if (this.connection === null) {
          this.connection = new HubConnectionBuilder()
            .withUrl(signalrUrl)
            .withAutomaticReconnect([0, 3000, 5000, 10000, 15000, 30000, 60000])
            .configureLogging(LogLevel.Information)
            .build()
          // Listen to "sendMessage"
          this.connection.on('sendMessage', (data) => {
            if (data !== undefined && data !== null) {
              if (globals.isJson(data)) {
                console.log('Incoming Message', JSON.parse(data))
              }
            }
          })
          // Start SignalR connection
          this.connection
            .start()
            .then(() => {
              console.log('Service Hub Started')
            })
            .catch((err) => {
              console.error(err.toString())
            })
        }
      } catch (e) {
        console.error('Error: serviceHub > initSignalR', e)
      }
    }
  },
  beforeDestroy() {
    this.connection.stop().then(() => {
      this.connection = null
      console.log('Service Hub Stopped')
    })
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/service-hub.vue